(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-details-guarantee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-details-guarantee')) {
    customElements.define('product-details-guarantee', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[role="tabpanel"]')];
        const select = (index, focus = false) => {
          tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; });
          if (focus) tabs[index].focus();
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(index), { signal });
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) { event.preventDefault(); select(next, true); }
          }, { signal });
        });
        const setFaq = (faq, open) => {
          faq.classList.toggle('is-open', open);
          faq.querySelector('.pdg__faq-toggle').setAttribute('aria-expanded', String(open));
          faq.querySelector('.pdg__faq-answer').inert = !open;
        };
        this.querySelectorAll('.pdg__faq-toggle').forEach(button => {
          button.addEventListener('click', () => setFaq(button.closest('.pdg__faq'), button.getAttribute('aria-expanded') !== 'true'), { signal });
        });
        this.addEventListener('shopify:block:select', event => { const faq = event.target.closest('.pdg__faq'); if (faq) { select(2); setFaq(faq, true); } }, { signal });
        this.querySelector('[role="tablist"]').hidden = false;
        this.setAttribute('data-ready', '');
        select(0);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
